import { User } from '@/interfaces/userInfo';
import Vue from 'vue';
import store from '@/store';
import permissions from './permissions';

export default async function (): Promise<void> {
	store.dispatch('tools/loading/changeLoadingStatus');
	if (Vue.$cookies.get('Global-Token')) {
		await store.dispatch('usermanagement/fetchGlobalUser');
		let userData: User = store.getters['usermanagement/user/getUser'];
		if (!userData || !permissions.checkClientSitePermission(userData)) {
			store.dispatch('usermanagement/authentication/logOut');
		} else {
			store.dispatch('usermanagement/authentication/changeLoginStatus', {
				status: true,
			});
			await store.dispatch('tenancy/fetchAllTenancy');
			if (Vue.$cookies.get('Token')) {
				await store.dispatch('usermanagement/fetchUser');
				userData = store.getters['usermanagement/user/getUser'];
				store.dispatch('tenancy/clients/selectClient', {
					client: store.getters['tenancy/clients/getClient'](userData.clients[0]),
				});
				store.dispatch('tenancy/sites/selectSite', {
					site: store.getters['tenancy/sites/getSite'](userData.sites[0]),
				});
				await store.dispatch('fetchAllData');
				store.dispatch('usermanagement/user/setUserRole', {
					userRole: permissions.checkUserRole(
						userData,
						store.getters['types/roles/getRoles'],
						store.getters['tenancy/sites/getSelectedSite']
					),
				});
			}
		}
	}
	store.dispatch('tools/loading/changeLoadingStatus');
}
